import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark?: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'BlogHubHero',
})(({ breakpoints, spacing, brandColors, typography }, props) => ({
  blogHubHero: {
    background: 'linear-gradient(136deg, #A5C9FF 0%, #FFFBF0 75.59%)',
  },
  blogHubHeroGridContainer: {
    rowGap: spacing(3),
    display: 'grid',
  },
  blogHubHeroHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
  blogHubEyebrow: {
    color: brandColors.tintsNeutral20,
    textAlign: 'center',
  },
  blogHubHeroCategories: {
    display: 'none',
    [breakpoints.up('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    gap: spacing(1),
  },
  blogHubHeroCategoriesDropdownContainer: {
    width: '100%',
    [breakpoints.up('sm')]: {
      display: 'none',
    },

    '& .MuiSelect-select': {
      backgroundColor: brandColors.white,
      borderRadius: typography.pxToRem(8),
      width: '100%',
      color: brandColors.tintsNeutral20,
    },
  },
  categoryPill: {
    padding: `${typography.pxToRem(12)} ${spacing(1)}`,
    border: 'none',
    borderRadius: typography.pxToRem(32),
    background: brandColors.white,
    cursor: 'pointer',

    '&:hover': {
      background: brandColors.tintsHeroBlue80,
    },
  },
  categoryPillActive: {
    background: brandColors.primaryMain,
    color: brandColors.white,

    '&:hover': {
      background: brandColors.mediumBlue,
    },
  },
  categoryPillNarrow: {
    padding: `${spacing(-1)} ${spacing(0)}`,
  },
  blogHubHeroFeaturedArticles: {
    minHeight: 0,
    minWidth: 0,
  },
  navigation: {
    display: 'flex',
    justifyContent: 'center',
    gap: spacing(3),
    marginTop: spacing(3),
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
  },
  navigationButton: {
    all: 'unset',
    width: typography.pxToRem(40),
    height: typography.pxToRem(40),
    [breakpoints.up('sm')]: {
      width: typography.pxToRem(60),
      height: typography.pxToRem(60),
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: typography.pxToRem(800),
    border: `${typography.pxToRem(1)} solid`,
    color: darkOrLightStyle(props)(brandColors.white, brandColors.primaryMain),
    borderColor: darkOrLightStyle(props)(
      brandColors.white,
      brandColors.primaryMain
    ),
    WebkitTapHighlightColor: 'transparent',
    outline: 'none',
    userSelect: 'none',
  },
  navigationButtonDisabled: {
    opacity: 0.3,
  },
  hidden: {
    visibility: 'hidden',
  },
  testimonialsContainer: {
    '& .swiper': {
      overflow: 'visible',
    },
  },
  swiperSlide: {
    width: 'auto',
    flexShrink: 0,
    position: 'relative',
  },
  horizontal: {
    display: 'flex',
  },
  pagination: {
    width: 'fit-content!important',
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0),
    '& .bullet': {
      color: darkOrLightStyle(props)(
        brandColors.tintsChargeBlue60,
        brandColors.tintsHeroBlue80
      ),
    },
    '& .bullet-active': {
      color: darkOrLightStyle(props)(
        brandColors.white,
        brandColors.primaryMain
      ),
    },
  },
}));

export default useStyles;
